<template >
    <el-dialog
            :title="'装备详情'"
            width="70%"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <div id="left" style="text-align: left">


            <el-table :data="dataList"  border style="width: 100%">


                <el-table-column prop="name" label="品名" width="100px">
                </el-table-column>
                <el-table-column prop="specification" label="规格">
                </el-table-column>
                <el-table-column prop="num" label="数量" sortable>

                </el-table-column>
                <el-table-column prop="unit" label="单位">

                </el-table-column>
                <el-table-column prop="price"  label="单价(元)" sortable>

                </el-table-column>
                <el-table-column prop="useTime" label="使用年限" >

                </el-table-column>
                <el-table-column prop="equipSize" label="尺寸" >

                </el-table-column>
                <el-table-column prop="time" label="发放日期" >
                    <template slot-scope="scope">
                        {{scope.row.time?scope.row.time.substr(0,10):''}}
                    </template>
                </el-table-column>
                <el-table-column prop="expireDate" label="过期日期" >
                    <template slot-scope="scope">
                        {{scope.row.expireDate?scope.row.expireDate.substr(0,10):''}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>


    import Template from "../../../template";
    export default {
        components: {Template},
        data () {
            return {
                visible: false,
                dataForm:{
                    recipient:'',
                    startTimest:'',
                    startTimeed:''
                },
                dataList:[]
            }
        },
        created () {

        },
        methods: {
            init (id) {
                if(!id) return
                this.visible = true
                this.dataList = []
                this.dataForm.recipient = id.recipient
                this.dataForm.startTimest = id.startTimest
                this.dataForm.startTimeed = id.startTimeed
                this.$http({
                    url: '/bjba/equip/outDeatil/findEquipExpireList',
                    method: 'get',
                    params:this.dataForm
                }).then(({data}) => {
                    this.dataList = data.data
                })
            }

        }
    }
</script>

<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
